import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

// TODO @Injectable()은 Spring @Service와 비슷한 것
//  설정에 따라 전역 서비스, 각 컴포넌트나 모듈별로 사용할 수 있음
//  기본 통신들을 모아놓은 서비스임
@Injectable({ providedIn: 'root' })
export class RestClientService {
  private readonly API_HOST: string; // environment.ts 파일에 정의되어 있음

  constructor(@Inject('API_HOST') private readonly apiHost: string,
              private readonly httpClient: HttpClient) {
    this.API_HOST = this.apiHost;
  }

  public get(path: string, params?: any, options: any = {}): Observable<any> {
    return this.httpClient.get<any>(this.createRequestUrl(path), {params, ...options});
  }

  public getFile(path: string): Observable<Blob> {
    return this.httpClient.get(this.createRequestUrl(path), {responseType: 'blob'});
  }

  public put(path: string, params?: any): Observable<any> {
    return this.httpClient.put<any>(this.createRequestUrl(path), params);
  }

  public patch(path: string, params?: any): Observable<any> {
    return this.httpClient.patch<any>(this.createRequestUrl(path), params);
  }

  public post(path: string, params?: any, options: any = {}): Observable<any> {
    return this.httpClient.post<any>(this.createRequestUrl(path), params, options);
  }

  public delete(path: string, params?: any): Observable<any> {
    return this.httpClient.delete<any>(this.createRequestUrl(path), {params});
  }

  public postForm(path: string, params?: any): Observable<any> {
    const formData = new FormData();
    this.createFormData(formData, params);
    return this.httpClient.post<any>(this.createRequestUrl(path), formData);
  }

  public patchForm(path: string, params?: any): Observable<any> {
    const formData = new FormData();
    this.createFormData(formData, params);
    return this.httpClient.patch<any>(this.createRequestUrl(path), formData);
  }

  public putForm(path: string, params?: any): Observable<any> {
    const formData = new FormData();
    this.createFormData(formData, params);
    return this.httpClient.put<any>(this.createRequestUrl(path), formData);
  }

  private createRequestUrl(path: string): string {
    return path.includes('http') ? path : `${this.API_HOST}${path}`;
  }

  private createFormData(formData: any, data: any, parentKey?: any): any {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File) && !(data instanceof Blob)) {
      Object.keys(data).forEach(key => {
        if (parentKey?.includes('[')) {
          this.createFormData(formData, data[key], parentKey ? `${parentKey}.${key}` : key);
        } else {
          this.createFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        }
      });
    } else if (data) {
      formData.append(parentKey, data);
    }
  }
}
